module.exports = __webpack_public_path__ + "static/home_05_mobile-e474074b01483fc479e06f17a171a91f.webp";